// Mirrors the constants defined in Base/src/main/java/com/bobex/model/CRMStatusModel.java
// Values reference rows in t_crmstatus.
export const CRMStatusConstants = {
    STATUS_NOTSTARTED: 10,
    STATUS_INPROGRESS: 15,
    STATUS_DEFERRED: 20,
    STATUS_CLOSED: 30,
    STATUS_WAITING: 40,
    STATUS_NA: 99,
} as const;
